import styled from "styled-components";

export const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffff;
  opacity: 0.5;
  video {
    height: 200px;
    min-width: 100%;
  }
`;
